/* eslint-disable jsx-a11y/anchor-is-valid */
import BrButton from '@govbr/react-components/lib/BrButton';
import { Grid } from '@material-ui/core';
import React, { createRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import * as mensagem from '../../common/Mensagens';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import configuration from '../../envConfig';
import styles from './ConsultaCpf.module.css';
import ReCAPTCHA from "react-google-recaptcha";
import {
  alterarDataNascimento,
  alterarCpf,
  getUfs,
  alterarMensagem,
  alterarTipoMensagem,
  ativarMensagem,
  selectState,
  selectComunicacaoAPI,
  verificarInfoUsuarioCadUnico,
  limpar,
  limparMensagemVerificacaoUsuario,
  selectVersaoMinimaAceitavel,
  selectPassCode,
  atualizarPassCode
} from './consultaCpfSlice';

import moment from 'moment';
import imgErro from '../../assets/img/icone-erro.png';
import imgAlerta from '../../assets/img/icone-alerta.png';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { selectLoadingCount, setLoggingIn } from '../../globalSlice';
import * as mensagens from '../../common/Mensagens';
import ReactInputDateMask from 'react-input-date-mask';
import ValidationMessage from '../../components/ValidationMessage/ValidationMessage';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker';
import TextField from '@mui/material/TextField';
import { validarCpf } from '../../common/validadores';
import { limparAuth, loginGateway, selectGovBr, setGovBrLogado } from '../../auth/authSlice';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import { APPLE_STORE_LINK, GOOGLE_PLAY_LINK } from '../../common/storeUtil';
import { calcularTempoRestanteDecursoPrazo } from '../../common/DateUtil';
import { SituacaoCadastroFamiliaUsuario } from '../../model/SituacaoCadastroFamiliaUsuario';
import authIdPositiva from '../../auth/AuthIdPositiva';
import { resetIdentificacaoPositiva } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { limparPerfil } from '../Perfil/perfilSlice';
import { limparDadosFamilia } from '../ConsultaSimples/consultaSimplesSlice';
import auth from '../../auth/Auth';
import { getConfiguracaoParametro, getDecursoPrazo, selectConfiguracaoParametro, selectDecursoPrazo } from '../Suporte/SuporteSlice';
import useConnectionStatus from '../../common/ConnectionStatus/ConnectionStatus';
import InternetConnectionError from '../../components/ConnectionStatus/ConnectionError';
import { reviewDialog } from '../../platformImpl/cordova/pushLib';

export const SCROLL_OFFSET_NAV_FIXED = configuration.isCordova ? -80 : -150;

const ConsultaCpf: React.FC = (props) => {
  const connectionStatus = useConnectionStatus();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const state = useAppSelector(selectState);

  const [dataNascimentoValida, setDataNascimentoValida] = useState(true);
  const [ popupIntervalId, setPopupIntervalId ] = useState(undefined as any);

  const temComunicacaoComAPI = useAppSelector(selectComunicacaoAPI);
  const temVersaoMinimaAceitavel = useAppSelector(selectVersaoMinimaAceitavel);

  const loadingCount = useAppSelector(selectLoadingCount);

  const passCode = useAppSelector(selectPassCode);
  const captcha = createRef<any>();

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  const habilitaAvaliacaoApp = useAppSelector(selectConfiguracaoParametro);

  useEffect(() => {
    dispatch(getDecursoPrazo());
    if (configuration.isCordova) {
      dispatch(getConfiguracaoParametro('HABILITA_AVALIACAO_APP'));
    }
  }, [])

  useEffect(() => {
    if (!state.situacaoCadastralPrePessoa &&
      state.mensagemVerificacaoUsuario &&
      state.usuarioEncontrado &&
      state.situacaoCadastralPessoa?.codigo === 3) {

      if (configuration.isCordova && habilitaAvaliacaoApp === 'HABILITADO') {
        setTimeout(() => { reviewDialog() }, 3000);
      }
    }
  }, [state.situacaoCadastralPrePessoa, state.mensagemVerificacaoUsuario, state.usuarioEncontrado, state.situacaoCadastralPessoa, habilitaAvaliacaoApp])

  useEffect(() => {
    if (govBrLogado) {
      history.replace('/home');
    }

    dispatch(getUfs());

    return () => {
      dispatch(limpar());
      dispatch(alterarMensagem(''));
      dispatch(ativarMensagem(false));
    };
  }, [dispatch, govBrLogado, history]);

  const validarCampos = () => {
    if (
      state.dataNascimento === '' ||
      state.dataNascimento === null ||
      !dataNascimentoValida ||
      state.cpf === '' ||
      state.cpf === null ||
      !isCpfValid()
    ) {
      return false;
    }
    return true;
  };

  const limparMensagens = () => {
    dispatch(alterarMensagem(''));
    dispatch(ativarMensagem(false));
  };

  const obterMensagemComTipo = (mensagem,tipoMensagem) => {
    setTimeout(() => {
      dispatch(ativarMensagem(false));
    }, 1000000);

    return (
      <div onClick={() => limparMensagens()}>
        <Message
          id="mensagem"
          type={tipoMensagem}
          title={'Atenção'}
          text={mensagem}
          className={styles.message}
        />
      </div>
    );
  };

  const handleMessage = (tipoMensagem, mensagem) => {
    dispatch(alterarTipoMensagem(tipoMensagem));
    dispatch(alterarMensagem(mensagem));
    dispatch(ativarMensagem(true));
  };

  const preencherCpf = (cpf) => {
    dispatch(ativarMensagem(false));
    dispatch(limparMensagemVerificacaoUsuario());
    dispatch(alterarCpf(cpf));
  }

  const consultarCpfCadUnico = async (passCode) => {
    //e.preventDefault();
    if (validarCampos()) {
      let dados = {
        cpf: state.cpf,
        dataNascimento: state.dataNascimento,
        passCode
      };

      if(passCode){
        const resultado = await dispatch(verificarInfoUsuarioCadUnico(dados));

        if (resultado.meta.requestStatus === 'fulfilled') {
          const shouldShowReview =
            state.situacaoCadastralPrePessoa === SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO ||
            state.situacaoCadastralPrePessoa === SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO ||
            (state.situacaoCadastralPessoa?.codigo === 1 && !state.situacaoCadastralFamilia);

          if(configuration.isCordova && shouldShowReview){
            //if(habilitaAvaliacaoApp==='HABILITADO'){
            if(true){
              setTimeout(()=> { reviewDialog() }, 3000);
            }
          }
        }
      }

    } else {
      handleMessage('warning', mensagem.MSG_CAD_UNICO_CAMPOS_OBRIGATORIOS);
    }
  };

  const handleDataNascimento = (newMoment: any) => {
    if (newMoment === null) {
      setDataNascimentoValida(true)
      return
    }

    setDataNascimentoValida(true)
    dispatch(ativarMensagem(false));
    dispatch(limparMensagemVerificacaoUsuario());

    let dataFormatada = moment(newMoment, 'YYYY-MM-DD')
    let dataString = moment(newMoment, 'YYYY-MM-DD').toISOString();

    if (moment(newMoment, 'YYYY-MM-DD').isAfter(moment())) {
      dispatch(alterarDataNascimento(dataString))
      setDataNascimentoValida(false)
      return
    }

    if (!dataFormatada.isValid()) {
      dispatch(alterarDataNascimento(dataString))
      setDataNascimentoValida(false)
      return
    }
    dispatch(alterarDataNascimento(dataString));
  };

  const handleDataNascimentoMobile = (newDate) => {
    setDataNascimentoValida(true)

    dispatch(ativarMensagem(false));
    dispatch(limparMensagemVerificacaoUsuario());

    let regexData = /^[0-9]{2}[/][0-9]{2}[/][0-9]{4}$/g
    let dataSemMascara = newDate.replace(/[/"]/g, '');

    try {
      let dataFormatada = moment(newDate, 'DD/MM/YYYY')

      if (dataFormatada.isValid() && !isNaN(dataSemMascara) && dataSemMascara.length === 8) {
        if (moment(newDate, 'DD/MM/YYYY').isAfter(moment())) {
          setDataNascimentoValida(false)
          dispatch(alterarDataNascimento(moment(moment(newDate, 'DD/MM/YYYY')).format('YYYY-MM-DD')));
        } else if (regexData.test(newDate)) {
          dispatch(alterarDataNascimento(moment(moment(newDate, 'DD/MM/YYYY')).format('YYYY-MM-DD')));
        }
      }

      if (!dataFormatada.isValid() || isNaN(dataSemMascara)) {
        setDataNascimentoValida(false)
      }
    } catch (err) {
      console.log(err)
      dispatch(alterarDataNascimento(''))
    }
  };

  const isCpfValid = () => {
    return !!state.cpf && validarCpf(state.cpf.toString());
  };

  const cpfValidationMsg = () => {
    if (state.cpf && !isCpfValid()) {
      return 'CPF inválido';
    }
    return '';
  };

  const requiredLabel = (label: string) => {
    return (
      <div className="flex flex-align-center">
        <span className={styles.inputLabel}>{label}</span>
        <span className="required">*</span>
      </div>
    );
  };

  const fecharMensagemAtualizacaoApp = () => {
    if (configuration.isCordova) {
      if (configuration.device.platform === 'IOS') {
        window.open(APPLE_STORE_LINK, '_system', 'location=yes');
      } else {
        window.open(GOOGLE_PLAY_LINK, '_system', 'location=yes');
      }
    }

    history.replace('/home');
  };

  const verificarCaptcha = async (e) => {
    e.preventDefault();
    if (!passCode) {
      captcha.current.reset();
      captcha.current.execute();
    } else {
      consultarCpfCadUnico(passCode);
    }
  };

  const onChange = async(responseGoogle) => {
    await dispatch(atualizarPassCode(responseGoogle));

    consultarCpfCadUnico(responseGoogle);
  }

  const entrarGovBr = () => {
    authIdPositiva.logout();
    dispatch(resetIdentificacaoPositiva());
    dispatch(limparPerfil());
    dispatch(limparDadosFamilia());
    dispatch(setLoggingIn(true));
    dispatch(loginGateway('/home'));

    if (!popupIntervalId) {
      setPopupIntervalId(setInterval(() => {
        if (auth.isAuthenticated()) {
          clearInterval(popupIntervalId);
          setPopupIntervalId(undefined);
          dispatch(setLoggingIn(false));
          dispatch(setGovBrLogado(true));
        } else if (auth.isAuthenticatedClose()) {
          clearInterval(popupIntervalId);
          setPopupIntervalId(undefined);
          dispatch(setLoggingIn(false));
          dispatch(limparAuth());
          auth.limparStorage();
          history.replace('/');
        }
      }, 500));
    }
  };

  return (
    <>
      <MainContainer
        barraAuxiliar={true}
        titleBarraAuxiliar="Consulta por CPF"
        padraoInicial={true}
        stoppedTitle={true}
      >
        <ReCAPTCHA
          ref={captcha}
          size='invisible'
          onChange={onChange}
          sitekey={configuration.captchaSiteKey}
        />

        <div className={styles.container}>
          {loadingCount > 0 && !temComunicacaoComAPI && (
            <Card className={styles.card}>
              <Skeleton count={15} />
            </Card>
          )}

          {!connectionStatus.isOnline && (
            <InternetConnectionError />
          )}

          {/**
           * Mostrando mensagem para atualização do app quando a versão estiver desatualizada.
           */}
          {connectionStatus.isOnline && loadingCount < 1 && !temComunicacaoComAPI && !temVersaoMinimaAceitavel && (
            <Card className={styles.card}>
              <div className={styles.containerMensagem}>
                <img className={styles.imgMessage} src={imgAlerta} alt="Imagem"/>
                <Message
                  type={'warning'}
                  text={
                    configuration.isCordova ? (
                      mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
                    ) : (
                      mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB
                    )
                  }
                />
                <div className={styles.botaoContainer}>
                  <BrButton onClick={() => fecharMensagemAtualizacaoApp()} className={styles.botao}>
                    OK
                  </BrButton>
                </div>
              </div>
            </Card>
          )}

          {/**
           * Mostrando mensagem de falta de comunicação com a API.
           */}
          {connectionStatus.isOnline && loadingCount < 1 && !temComunicacaoComAPI && temVersaoMinimaAceitavel && (
            <Card className={styles.card}>
              <div className={styles.containerMensagem}>
                <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
                <Message
                  type={'error'}
                  text={mensagens.MSG_ERRO_COMUNICACAO_API}
                />
                <div className={styles.botaoContainer}>
                  <BrButton onClick={() => history.replace('/home')} className={styles.botao}>
                    OK
                  </BrButton>
                </div>
              </div>
            </Card>
          )}

          {connectionStatus.isOnline && temComunicacaoComAPI && temVersaoMinimaAceitavel &&
            <Card className={styles.card}>
              <div className={styles.form}>
                <Grid container spacing={2}>

                  <Grid item xs={8} md={4}>
                    <div className={`br-input ${!isCpfValid() ? 'error' : ''}`}>
                      <label>{requiredLabel('Número do CPF')}</label>
                      <input
                        id="numeroCpfPessoa"
                        type="text"
                        placeholder="000.000.000-00"
                        maxLength={11}
                        onChange={(e) => preencherCpf(e.target.value as any)}
                        value={state.cpf}
                      />
                    </div>
                    {!isCpfValid() && cpfValidationMsg() && (
                      <ValidationMessage text={cpfValidationMsg()} />
                    )}

                  </Grid>
                  <Grid item xs={12} md={6}>
                    {configuration.isCordova &&
                      <div className={`br-input ${!dataNascimentoValida ? 'error' : ''}`}>
                        <label>{requiredLabel("Data de Nascimento")}</label>
                        <Grid item xs={12} sm={6}>
                          <ReactInputDateMask
                            mask='dd/mm/yyyy'
                            showMaskOnFocus={true}
                            value={state.dataNascimento ? moment(state.dataNascimento).format('DD/MM/YYYY') : ''}
                            onChange={(e) => handleDataNascimentoMobile(e)}
                            showMaskOnHover={true} />
                        </Grid>
                      </div>
                    }
                    {!configuration.isCordova &&
                      <div className={`br-input br-datepicker ${!dataNascimentoValida ? 'error' : ''}`}>
                        <label>{requiredLabel("Data de Nascimento")}</label>
                          <Grid item xs={12} sm={6}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DesktopDatePicker
                                onChange={(e) => handleDataNascimento(e)}
                                value={
                                  state.dataNascimento
                                    ? moment(state.dataNascimento).format('YYYY-MM-DD')
                                    : ''
                                }
                                inputFormat="DD/MM/yyyy"
                                closeOnSelect={true}
                                showDaysOutsideCurrentMonth={true}
                                renderInput={(params) => {
                                  if (params.inputProps !== undefined) {
                                    params.inputProps.placeholder = 'dd/mm/aaaa';
                                    params.error = !dataNascimentoValida;
                                  }
                                  return <TextField {...params} />
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>
                      </div>
                    }

                    {!dataNascimentoValida &&
                      <ValidationMessage text={'Data inválida ou maior que a atual.'} />
                    }
                  </Grid>

                </Grid>
              </div>

              {state.mensagemVerificacaoUsuario && !state.usuarioEncontrado && (
                <Message
                  type={"warning"}
                  title={state.mensagemVerificacaoUsuario}
                  className={styles.message}
                />
              )}
              {state.mensagemVerificacaoUsuario &&  (state.situacaoCadastralPessoa?.codigo === 1) && (
                <div className={`${styles.containerMessage} ${styles['warning']} ${styles.containerMargin}`}>
                  <div className={`${styles.titleWrapper}`}>
                      <i className={`fas fa-exclamation-triangle ${styles.iconWarning}`}></i>
                      <span className={styles.title}>

                        {state.situacaoCadastralPessoa?.codigo === 1 && state.usuarioEncontrado  &&
                          <>
                            {`Você foi incluído em uma família no Cadastro Único, mas seu cadastro ainda não está completo. O Responsável Familiar
                            tem ${calcularTempoRestanteDecursoPrazo(state.informacaoPeriodoRetornoCadastramento?.dataCadastramento, decursoPrazo)}
                            dia(s) para ir ao CRAS ou posto de atendimento do Cadastro Único e complementar o seu cadastro.
                            Caso não compareça, a sua solicitação será excluída. Para mais informações, `}
                            <a style={{ cursor: 'pointer' }} onClick={() => { entrarGovBr() }}>
                              entre com sua conta gov.br
                            </a>
                            {` e acesse a `}
                            <strong>Consulta ao formulário</strong>.
                          </>
                        }
                      </span>
                  </div>
                </div>
              )}

              {state.mensagemVerificacaoUsuario && state.usuarioEncontrado && state.situacaoCadastralPessoa?.codigo !== 1 && (
                <div
                  className={`${styles.containerMessage} ${styles['success']} ${styles.containerMargin}`}
                >
                  <div className={`${styles.titleWrapper}`}>
                    <i className={`fas fa-check-circle ${styles.icon} success `}></i>
                    <span className={styles.title}>
                      {`Você está cadastrado no Cadastro Único. Para mais informações, clique em `}
                      <a style={{ cursor: 'pointer' }} onClick={() => { entrarGovBr() }}>
                        Entrar com o gov.br
                      </a>
                      {` e acesse a `}
                      <strong>Consulta ao formulário</strong>.
                    </span>
                  </div>
                </div>
              )}

              {state.ativarMensagem && obterMensagemComTipo(state.mensagem,state.tipoMensagem)}
              <div className={styles.center}>
                <BrButton
                  id="botaoContinuar"
                  className={styles.botaoGovBr}
                  disabled={!validarCampos()}
                  onClick={(e) => verificarCaptcha(e)}
                >
                  Consultar
                </BrButton>
              </div>
            </Card>}
            <AjudaRapida scrollOffset={SCROLL_OFFSET_NAV_FIXED}>
              <div className={styles.textoAjudaRapida}>
                Descubra se sua família está cadastrada no Cadastro Único, informando apenas do CPF e data de nascimento. Se estiver, você pode acessar os dados com sua conta Gov.br.
              </div>
            </AjudaRapida>

        </div>
      </MainContainer>
    </>
  );
};

export default ConsultaCpf;
